<div class="ant-slider-step">
  <span class="ant-slider-dot" *ngFor="let mark of steps; trackBy: trackById" [class.ant-slider-dot-active]="mark.active" [ngStyle]="mark.style!"></span>
</div>
